// ********************************************************
// Archive
// Handles create-vehicles archive loading/saving
// ********************************************************

import * as Backend from '@/core/backend'

export async function loadVehicles (param) {
  const res = await Backend.callApi({
    // apiName: 'Archive.LoadVehicles',
    apiName: 'CreateVehicles.LoadVehicles',
    inputData: {
      // MITH special: If facility is '' show all vehicles for all facilities (we use facility = null).
      Facility: param.facility === '' ? null : param.facility,
      SearchText: param.searchText,
      LoadDeleted: param.loadDeleted !== null ? param.loadDeleted : true // load Deleted, if we need to show all inactive Vehicles
    }
  })
  return res
}

export async function loadVehicle (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadVehicle',
    inputData: {
      Facility: params.facilityNo,
      No: params.vehicleNo
    }
  })
  return res
}

export async function ReDeactivateVehicle (params) {
  const res = await Backend.callApi({
    apiName: 'CreateVehicles.ReDeactivateVehicle',
    inputData: {
      Id: params.Id,
      Facility: params.Facility,
      No: params.No,
      LicensePlateNo: params.LicensePlateNo,
      Activate: params.Activate
    }
  })
  return res
}

export async function saveVehiclesAndUsers (vehicle) {
  const res = await Backend.callApi({
    apiName: 'CreateVehicles.SaveVehiclesAndUsers',
    inputData: {
      Vehicles: [vehicle]
    }
  })
  return res
}

export async function isVehicleUser () {
  const res = await Backend.callApi({
    apiName: 'CreateVehicles.IsVehicleUser',
    inputData: { }
  })
  return res
}
